import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RchRoutingModule } from "./rch-routing.module";
import { Step1Component } from "./step1/step1.component";
import { MainComponent } from "./main/main.component";
import { Step3Component } from "./step3/step3.component";
import { Step4Component } from "./step4/step4.component";
import { Step5Component } from "./step5/step5.component";
import { CommitComponent } from "./commit/commit.component";
import { ReceiptComponent } from "./receipt/receipt.component";
import { StatusComponent } from "./status/status.component";
import { ModelRestService } from "../model-rest.service";
import { SessionService } from "../session.service";
import { FormsModule } from "@angular/forms";
import { RecaptchaModule } from "ng-recaptcha";
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from "ng-recaptcha";
import { RECAPTCHA_LANGUAGE } from "ng-recaptcha";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
  NgbModule,
  NgbDateAdapter,
  NgbDatepickerModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgbDateNativeAdapter } from "../NgbDateNativeAdapter";
import { StopcheckDirective } from "../stopcheck.directive";
import { CostBoxComponent } from "./cost-box/cost-box.component";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpLoaderFactory } from "../app.module";
import { PaymentComponent } from "./payment/payment.component";
import { ConfirmComponent } from "./confirm/confirm.component";
import { LoadingComponent } from "./loading/loading.component";
import { TravelBoxComponent } from "./shared/travel-box/travel-box.component";
import { MustMatchDirective } from "../directives/must-match.directive";
import { CommitwppComponent } from "./commitwpp/commitwpp.component";
import { CommitwpprefComponent } from "./commitwppref/commitwppref.component";
import { PaymentwppComponent } from "./paymentwpp/paymentwpp.component";
import { SharedComponentsModule } from "./shared/shared-components.module";
import { TravelBoxWppComponent } from "./shared/travel-box-wpp/travel-box-wpp.component";

@NgModule({
  imports: [
    CommonModule,
    RchRoutingModule,
    FormsModule,
    HttpClientModule,
    NgbDatepickerModule,
    SharedComponentsModule,
    RecaptchaModule.forRoot(),
    NgbModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
    Step1Component,
    MainComponent,
    Step3Component,
    Step4Component,
    Step5Component,
    CommitComponent,
    ReceiptComponent,
    StatusComponent,
    StopcheckDirective,
    CostBoxComponent,
    PaymentComponent,
    ConfirmComponent,
    LoadingComponent,
    TravelBoxComponent,
    MustMatchDirective,
    CommitwppComponent,
    PaymentwppComponent,
    CommitwpprefComponent,
    TravelBoxWppComponent
  ],
  providers: [
    ModelRestService,
    SessionService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: "6Lc5P8oUAAAAAB9MnjS4SOmJbx7Dy7wUYbWpsdlP",
      } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: "es",
    },
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
  ],
})
export class RchModule {}
